import React, { useState, useEffect } from "react";

const Card = ({ value, handleClick, setBgColor, refr, isNumber }) => {
  const [select, setSelect] = useState(false);
  const [refresh, setRefresh] = useState(refr);
  const [isFixed, setIsFixed] = useState(false);
  const [background, setBackground] = useState("#F3F4FD");

  useEffect(() => {
    setSelect(false);
    setIsFixed(false);
  }, [refr]);
  return (
    <button
      className="border-solid border-slate-400 border-2 p-2 mx-2 h-24  min-w-fit w-24 rounded text-2xl hover:bg-slate-200 "
      value={value}
      onClick={() => {
        setSelect(!select);
        if (!isFixed) {
          setBackground(setBgColor(isNumber));
          setIsFixed(true);
        }

        handleClick(value, select);
      }}
      style={select ? { background } : {}}
    >
      {value}
    </button>
  );
};

export default Card;
